module.exports = __webpack_public_path__ + "static/media/Brute Tigrex.6600d034.png";


//////////////////
// WEBPACK FOOTER
// ./src/eggs/images/Brute Tigrex.png
// module id = 102
// module chunks = 0